import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/showcase/Content.tsx");
